export default __webpack_public_path__ + "static/media/PAVED-Paper-Preview.035c6eee.png";